import { Component, ElementRef, HostListener, OnInit } from '@angular/core';
import { CustomerModel } from 'src/app/models/customer-model';
import { ConfigService } from 'src/app/services/config/config.service';
import { EventsService } from 'src/app/services/event/event.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { WebservicesService } from 'src/app/services/webservices/webservices.service';
import { Navigator } from '../../menu/navigator';
import { gsap } from 'gsap';
import { Platform } from '@ionic/angular';
import { AudioService } from 'src/app/services/audio/audio.service';
import { DisplayMode, OrientationService } from 'src/app/services/orientation/orientation.service';
import { isUndefined } from 'src/app/services/codeUtils';
import { distinctUntilChanged, filter, map, takeUntil } from 'rxjs/operators';
import { Subject, Subscription } from 'rxjs';


@Component({
  selector: 'app-footer-bonus-rocket',
  templateUrl: './footer-bonus-rocket.component.html',
  styleUrls: ['./footer-bonus-rocket.component.scss'],
})

export class FooterBonusRocketComponent implements OnInit {

  public customerId: number;
  protected showRocketLaunchButton: boolean = true;
  protected timeLeft: number = undefined;
  protected enabled: boolean = false;
  protected showTimer: boolean = true;
  protected startAnimation: boolean = false;
  protected isRocketAnimationCompleted: boolean = false;
  protected isMobile: boolean = false;
  protected isPortrait: boolean = false;
  protected isLoggedIn: boolean = false;
  protected displayMode: DisplayMode; 
  private customerSubscription: Subscription | null = null;
  private destroy$ = new Subject<void>();
  private stopTimer:boolean = false;

  constructor(
    protected utilsService: UtilsService, //used in HTML
    private userSessionService: UserSessionService,
    private webservices: WebservicesService,
    private config: ConfigService,
    private eventService: EventsService,
    private el: ElementRef,
    private navigator: Navigator,
    private audioService: AudioService,
    private readonly platform: Platform,
    private readonly orientationService: OrientationService,
  ) {

    this.eventService.subscribe('event:call:rocketLaunch:timer', () => {
      this.showTimer = true;
      const rocketElement = this.el.nativeElement.querySelector('.footer-bonus-rocket-part');
      rocketElement.style.opacity = '1';
      rocketElement.style.scale = '1';
      rocketElement.style.transform = 'rotate(0deg) translate3d(-2px, 19px, 10px)';
      const rocketString = this.el.nativeElement.querySelector('.footer-bonus-rocket-string');
      const rocketSpark = this.el.nativeElement.querySelector('.footer-bonus-rocket-fuse');
      rocketString.style.opacity = '1';
      rocketSpark.style.opacity = '1';
      this.isUserLoggedIn();
    });

    this.eventService.subscribe("event:authentication:logout", () => (this.customerId = null));

  }

  ngOnDestroy() {
    this.eventService.destroy('event:appStateChange');
    this.stopTimer = true;
  }

  ngOnInit() {
    this.adjustRocketComponent();
    this.config.isLoaded().then(() => {this.isUserLoggedIn();})
    //this.userSessionService.getCustomerSubscription();

    this.orientationService.displayMode$.subscribe((mode) => {
      this.displayMode = mode;
    });
    this.orientationService.handleOrientationChange();
    this.checkAppState();
  }

  checkAppState() {
    this.eventService.subscribe('event:appStateChange', (isActive) => {
      if (isActive) {
        this.enabled = true;
        this.stopTimer = false;
        setTimeout(() => {
          this.checkRocketBonusForUser();
        }, 500); 
      } else {
        this.stopTimer = true;
        this.enabled = false;
      }
    });
  }

  protected isUserLoggedIn() {
    this.customerSubscription?.unsubscribe();
    this.userSessionService.getCustomerSubscription().then((obs) => {
      this.customerSubscription = obs
        .pipe(
          takeUntil(this.destroy$),
          filter((customer) => !!customer),
          map((customer) => customer.customerId),
          distinctUntilChanged()
        )
        .subscribe((customerId) => {
          if (customerId) {
            this.customerId = customerId;
            this.isLoggedIn = true;
            this.initializeRocketLauncherDataForUser();
          } else {
            this.enabled = false;
            this.isLoggedIn = false;
          }
        });
    }); 
  }


  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.adjustRocketComponent();
  }

  private adjustRocketComponent() {
    this.isMobile = this.platform.is('mobile');
    this.isPortrait = this.platform.isPortrait();
  }

  initializeRocketLauncherDataForUser() {
    this.config.isLoaded().then((config) => {
      setTimeout(() => { this.checkRocketBonusForUser(); }, 400);
    });
  }

  launchRocketBonusForUser() {
    if(this.isRocketBonusAvailable()){
      this.audioService.playSound("RocketStart");
      this.userSessionService.isAuthenticated().then((isAuthenticated) => {
        if (isAuthenticated) {
          this.webservices.get('bonus/get-rocket-bonus', {
            customer_id: this.customerId,
            session_token: this.userSessionService?.sessionToken
          }).subscribe((res) => {
            if (res.result) {
              this.startAnimation = true;
              if(res.payload.winning_options) {
                setTimeout(() => {
                  this.loadRocketBonusWheel(res.payload)
                }, 600);
    
                setTimeout(() => {
                  this.checkRocketBonusForUser();
                }, 500);  
              }
            }
          })
        } else {
          this.enabled = false;
        }
      });
    }
   
  }

  checkRocketBonusForUser() {
    this.userSessionService.isAuthenticated().then((isAuthenticated) => {
      if (isAuthenticated) {
        this.webservices.get('bonus/next-rocket-bonus', {
          customer_id: this.customerId,
          session_token: this.userSessionService?.sessionToken
        }).subscribe((res) => {
          if (res.result) {
            this.setTimeLeft(res.payload.seconds_remaining);
          }
        })
      } else {
        this.isLoggedIn = false
        this.enabled = false;
      }
    });
  }


  setTimeLeft(timeLeft: number) {
    if (timeLeft <= 0) {
      this.timeLeft = timeLeft;
      setTimeout(() => {
        this.animateLaunchButton();
      }, 500);
      return;
    } else {
      this.enabled = true;
      this.timeLeft = timeLeft;
      if (timeLeft - 1 >= 0 && !this.stopTimer) {
        setTimeout(() => this.setTimeLeft(timeLeft - 1), 1000);
      }
    }
  }

  isRocketBonusAvailable(): any {
    return this.timeLeft <= 0;
  }

  animateLaunchButton() {
    gsap.fromTo('.footer-bonus-launch-button-inner', {
      scale: 1,
    }, {
      scale: 0.8,
      duration: 1.5,
      repeat: -1,
      yoyo: true,
      ease: "power1.inOut"
    });
  }

  loadRocketBonusWheel(params?: any) {
    this.showTimer = false;
    this.doRocketSparkAnimation();
    setTimeout(() => {
      //this.doRocketElementMotionPathHelper(params);
      const rocketElement = this.el.nativeElement.querySelector('.footer-bonus-rocket-part');
      rocketElement.style.opacity = '0';
      this.navigator.navigateTo('RocketBonusGameLaunchComponent', { customModalClass: 'rocket-modal', backdropDismiss: false }, { gameData: params });
    }, 1000);

  }

  doRocketSparkAnimation() {
    this.audioService.playSound("RocketHiss");
    gsap.fromTo('.footer-bonus-rocket-fuse', {
      scale: 1,
      right: '48px'
    }, {
      scale: 1.4,
      right: '15px',
      duration: 1,
      repeat: 1,
      yoyo: true,
      ease: "power1.inOut"
    });
  }

 /* doRocketElementMotionPathHelper(params?: any) {
    const ionPage: HTMLIonAppElement = document.querySelector('.ion-page');
    ionPage.classList.add('overlay');
    const rocketString = this.el.nativeElement.querySelector('.footer-bonus-rocket-string');
    const rocketSpark = this.el.nativeElement.querySelector('.footer-bonus-rocket-fuse');
    rocketString.style.opacity = '0';
    rocketSpark.style.opacity = '0';
    const getRocketPathFromApp = document.querySelector('.rocket-motion-section') as HTMLElement;
    getRocketPathFromApp.style.display = 'block';
    this.eventService.publish("event:adjust:rocket:animation:svg:path");
    const findRocketPart = document.querySelector('.footer-bonus-rocket-container') as HTMLElement;
    findRocketPart.style.display = 'flex';
    const rocketElement = document.querySelector('.footer-bonus-rocket-main') as HTMLElement;
    const footer = document.querySelector('app-site-footer') as HTMLElement;
    footer.style.opacity = '0.1';
    const svgPath = document.querySelector('#path') as SVGPathElement;

    //workaround to include ionic angular function inside GSAP
    var returnStatement
    setTimeout(() => {
      returnStatement = this.navigator.navigateTo('RocketBonusGameLaunchComponent', { customModalClass: 'rocket-modal', backdropDismiss: false }, { gameData: params });;
    }, 5200);

    const rocketAnimationTimeLine = gsap.timeline();

    const rocketContextSetup = gsap.set(rocketElement, { scale: 1.1, autoAlpha: 1 });

    const animationDuration = 2;
    const initialScale = 1.1;
    const finalScale = 2;
    const start = 0.0;
    const end = 0.3;
    const rocketContext = gsap.to(rocketElement, {
      duration: animationDuration,
      ease: "power1.inOut",
      immediateRender: true,
      motionPath: {
        path: svgPath,
        align: svgPath,
        alignOrigin: [0.5, 0.5],
        autoRotate: 70,
        start: start,
        end: end
      },
      paused: false,
      zIndex: 999,
      alignContent: 'center',
      scale: initialScale, // Initial scale
      onUpdate: () => {
      },
      onStart: () => {
        rocketElement.style.scale = '1.1';
        this.audioService.playSound("RocketWheelSequence_rocket1_start");
      },
      onComplete: () => {
        console.log('Animation completed: Part 1');
      }
    });

    const rocketContext2 = gsap.to(rocketElement, {
      duration: 3,
      ease: "power1.inOut",
      immediateRender: true,
      motionPath: {
        path: svgPath,
        align: svgPath,
        alignOrigin: [0.5, 0.5],
        autoRotate: 70,
        start: 0.299,
        end: 1
      },
      alignContent: 'center',
      zIndex: 999,
      paused: false,
      scale: 3,
      onUpdate: () => {
      },
      onStart: () => {
        rocketElement.style.scale = '1.1';
        this.audioService.playSound("RocketWheelSequence_rocket2_end");
      },
      onComplete: () => {
        console.log('Animation completed: Part 2');
        const getRocketPathFromApp = document.querySelector('.rocket-motion-section') as HTMLElement;
        getRocketPathFromApp.style.display = 'none';
        findRocketPart.style.display = 'none';
        footer.style.opacity = '1';
        rocketContext2.kill();

        returnStatement;
      }
    });



    MotionPathHelper.create(rocketElement, {
      selected: false,
      path: svgPath,
      ease: 'power1.inOut'
    });

    rocketContext.repeat(0);
    rocketContext2.repeat(0);
    rocketAnimationTimeLine.add(rocketContextSetup);
    rocketAnimationTimeLine.add(rocketContext);
    rocketAnimationTimeLine.add(rocketContext2);
    rocketAnimationTimeLine.play();

  }*/


}

